exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.emp-label {\n    white-space: nowrap;\n    font-size: 12px;\n    font-weight: 600;\n    background: white;\n    padding: 1px 5px;\n    border-radius: 3px;\n    box-shadow: 0 1px 3px rgba(0,0,0,0.3);\n}\n.emp-dot {\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    background: #2b7fe7;\n    border: 2px solid white;\n    box-shadow: 0 1px 3px rgba(0,0,0,0.4);\n    flex-shrink: 0;\n    margin-right: 5px;\n}\n.map-parent {\n    display: flex;\n    flex-direction: column;\n    height: calc(100vh - 50px);\n    width:100%;\n    padding:16px;\n}\n.popup br {\n    margin:5px 0;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6bc69bb5","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/view/Timesheet_Map.vue
// module id = 589
// module chunks = 0